import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import * as yup from 'yup';

import { DateInput } from '@components/DateInput/DateInput';

import { CustomPicker } from './Components/CustomPickerWithBorder/CustomPicker';
import {
  Container,
  Title,
  Line,
  Column,
  Input,
  Divider,
  TextArea,
  DisabledWrapper,
} from './Details.styles';
import { getEnabledMap, options, getDateLabel } from './Details.utils';
import { IDetails, IDetailsFormData } from './types';

const schema = yup
  .object({
    title: yup.string().required(),
    description: yup.string().required(),
    priority: yup
      .string()
      .oneOf(['uncertain', 'non-critical', 'important', 'urgent', null])
      .nullable(),
    date: yup.date().nullable(),
  })
  .required();

const Details = (props: IDetails) => {
  const { mode, onValidChange, broadcast, task } = props;

  const [enabledMap] = useState(() => getEnabledMap(mode));

  const {
    register,
    control,
    formState: { isValid },
    watch,
  } = useForm<IDetailsFormData>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      title: task?.title || '',
      description: task?.description || '',
      priority: task?.priority || null,
      date: task?.dueDate || null,
    },
  });
  useEffect(() => {
    broadcast(watch());
    const subscription = watch(values => {
      broadcast(values);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    onValidChange(isValid);
  }, [isValid]);

  const disablePastDates = mode !== 'editing.insights';

  return (
    <Container>
      <form>
        <Line>
          <div className="DetailColumn">
            {enabledMap.get('title') && (
              <Column>
                <Title>Title</Title>
                <Input
                  type="text"
                  autoFocus
                  placeholder="Ex: Studio 3 Maintenance Shutdown"
                  {...register('title')}
                />
              </Column>
            )}

            {enabledMap.get('description') && (
              <Column>
                <Title>Description</Title>
                <Divider height="8px" />
                <TextArea
                  placeholder="Add a description"
                  {...register('description')}
                />
              </Column>
            )}
          </div>
          <Column className="priorityWrapper DetailColumn">
            {enabledMap.get('priority') && (
              <Column className="priorityWrapper">
                <Title className="optional">Priority (Optional)</Title>
                <Divider height="8px" />
                <Controller
                  control={control}
                  name="priority"
                  render={({ field: { onChange, value } }) => (
                    <CustomPicker
                      options={options}
                      value={options.find(c => c.value === value)}
                      onChange={(val: any) => {
                        onChange(val.value);
                      }}
                      placeholder="Choose..."
                    />
                  )}
                />
              </Column>
            )}

            {enabledMap.get('date') && (
              <DisabledWrapper>
                <Title className="optional">
                  {getDateLabel(mode)} (Optional)
                </Title>
                <Divider height="8px" />
                <Controller
                  control={control}
                  name="date"
                  render={({ field: { onChange, value } }) => (
                    <DateInput
                      placeholder="Choose..."
                      height={42}
                      value={value ?? null}
                      disablePast={disablePastDates}
                      handleDateChange={newDate => {
                        let convDate: Date | null = null;
                        if (newDate) convDate = new Date(newDate);
                        onChange(convDate);
                      }}
                    />
                  )}
                />
              </DisabledWrapper>
            )}
          </Column>
        </Line>
      </form>
    </Container>
  );
};

export { Details };
